import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "table-header-item-count" }
const _hoisted_2 = { style: {"text-decoration":"underline"} }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { class: "pb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_TableHeader = _resolveComponent("TableHeader")!
  const _component_TextHighlights = _resolveComponent("TextHighlights")!
  const _component_v_data_table_server = _resolveComponent("v-data-table-server")!
  const _component_v_infinite_scroll = _resolveComponent("v-infinite-scroll")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_SingleFilter = _resolveComponent("SingleFilter")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_NowhowDatepicker = _resolveComponent("NowhowDatepicker")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_FilterDrawer = _resolveComponent("FilterDrawer")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_infinite_scroll, { onLoad: _ctx.load }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_data_table_server, {
                    "sort-by": _ctx.sortBy,
                    "onUpdate:sortBy": [
                      _cache[3] || (_cache[3] = ($event: any) => ((_ctx.sortBy) = $event)),
                      _ctx.onSortByChanged
                    ],
                    headers: _ctx.headers,
                    items: _ctx.lieferantenDokumentList,
                    loading: _ctx.loading,
                    "item-value": "dokumentID",
                    "items-length": _ctx.totalNumberOfRecords || 0,
                    "hide-default-footer": "",
                    class: "elevation-1",
                    "must-sort": true,
                    hover: ""
                  }, {
                    top: _withCtx(() => [
                      _createVNode(_component_TableHeader, {
                        filters: _ctx.filters,
                        onChipClosed: _ctx.removeFilter
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.totalNumberOfRecords + ' ' + _ctx.$t('lieferantendokument.archiv.table.header.items')), 1),
                          (_ctx.showSearchBar)
                            ? (_openBlock(), _createBlock(_component_v_text_field, {
                                key: 0,
                                modelValue: _ctx.filterData.suchText,
                                "onUpdate:modelValue": [
                                  _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterData.suchText) = $event)),
                                  _ctx.searchFieldInputChanged
                                ],
                                class: "ml-5",
                                "prepend-inner-icon": "mdi-magnify",
                                "append-icon": "mdi-close",
                                label: _ctx.$t('lieferantendokument.archiv.table.header.searchlabel'),
                                "hide-details": "",
                                autofocus: "",
                                "onClick:append": _ctx.searchBarClosed
                              }, null, 8, ["modelValue", "label", "onUpdate:modelValue", "onClick:append"]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_v_spacer),
                          _createVNode(_component_v_tooltip, {
                            top: "",
                            color: "secondary"
                          }, {
                            activator: _withCtx(({ props }) => [
                              _createVNode(_component_v_btn, _mergeProps(props, {
                                icon: "",
                                color: "primary"
                              }), {
                                default: _withCtx(() => [
                                  (!_ctx.showSearchBar)
                                    ? (_openBlock(), _createBlock(_component_v_icon, {
                                        key: 0,
                                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showSearchBar = !_ctx.showSearchBar))
                                      }, {
                                        default: _withCtx(() => _cache[13] || (_cache[13] = [
                                          _createTextVNode("mdi-magnify")
                                        ])),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1040)
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t('lieferantendokument.tableheader.tooltip.search')), 1)
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_tooltip, {
                            top: "",
                            color: "secondary"
                          }, {
                            activator: _withCtx(({ props }) => [
                              _createVNode(_component_v_btn, _mergeProps(props, {
                                icon: "",
                                color: "primary",
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showFilterDrawer = !_ctx.showFilterDrawer))
                              }), {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => _cache[14] || (_cache[14] = [
                                      _createTextVNode("mdi-filter-outline")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 2
                              }, 1040)
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t('tableheader.tooltip.filter')), 1)
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["filters", "onChipClosed"])
                    ]),
                    "item.titel": _withCtx(({ item }) => [
                      _createVNode(_component_TextHighlights, {
                        text: item.titel,
                        "search-text": _ctx.filterData.suchText
                      }, null, 8, ["text", "search-text"])
                    ]),
                    "item.bezeichnung": _withCtx(({ item }) => [
                      _createElementVNode("a", _hoisted_2, [
                        _createVNode(_component_TextHighlights, {
                          text: item.bezeichnung,
                          "search-text": _ctx.filterData.suchText,
                          onClick: ($event: any) => (
                                        _ctx.openDokument({
                                            id: item.dokumentGuid,
                                            dateiTyp: item.mimeTyp,
                                            dokumentName: item.bezeichnung
                                        })
                                    )
                        }, null, 8, ["text", "search-text", "onClick"])
                      ])
                    ]),
                    "item.dokumentKategorieCode": _withCtx(({ item }) => [
                      (item.dokumentKategorieCode == 'Vertrag')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t('lieferanten.dokument.dokumenkategorie.vertrag')), 1))
                        : (item.dokumentKategorieCode == 'Lieferanteninformation')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.$t('lieferanten.dokument.dokumenkategorie.lieferanteninformation')), 1))
                          : (item.dokumentKategorieCode == 'Public')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t('lieferanten.dokument.dokumenkategorie.public')), 1))
                            : (item.dokumentKategorieCode == 'Individuell')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t('lieferanten.dokument.dokumenkategorie.individuell')), 1))
                              : _createCommentVNode("", true)
                    ]),
                    "item.link": _withCtx(({ item }) => [
                      _createVNode(_component_v_btn, {
                        icon: "",
                        class: "elevation-0",
                        href: item.link,
                        onClick: ($event: any) => (
                                    _ctx.downloadDokument({
                                        id: item.dokumentGuid,
                                        dokumentName: item.bezeichnung
                                    })
                                )
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            color: "primary",
                            icon: "mdi-download-outline"
                          })
                        ]),
                        _: 2
                      }, 1032, ["href", "onClick"])
                    ]),
                    _: 1
                  }, 8, ["sort-by", "headers", "items", "loading", "items-length", "onUpdate:sortBy"])
                ]),
                _: 1
              }, 8, ["onLoad"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_FilterDrawer, {
        visible: _ctx.showFilterDrawer,
        "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.showFilterDrawer) = $event)),
        onCancel: _cache[9] || (_cache[9] = ($event: any) => (_ctx.cancelFilter())),
        onConfirm: _cache[10] || (_cache[10] = ($event: any) => (_ctx.confirmFilter())),
        onClear: _cache[11] || (_cache[11] = ($event: any) => (_ctx.clearFilters(true))),
        onReset: _cache[12] || (_cache[12] = ($event: any) => (_ctx.clearFilters(false)))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_SingleFilter, {
            title: _ctx.$t('lieferantendokument.archiv.table.header.dokumentKategorie')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select, {
                        modelValue: _ctx.filterData.dokumentKategorieCode,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filterData.dokumentKategorieCode) = $event)),
                        variant: "filled",
                        density: "compact",
                        "hide-details": "",
                        items: _ctx.dokumentKategorien
                      }, null, 8, ["modelValue", "items"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(_component_SingleFilter, {
            title: "",
            class: "py-0 mt-0"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_radio_group, {
                modelValue: _ctx.radios,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.radios) = $event)),
                class: "pb-0 filterLine",
                inline: ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("h5", _hoisted_7, _toDisplayString(_ctx.$t('archiv.filter.title.datum')), 1),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "pt-0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_radio, {
                        value: "selectTime",
                        label: _ctx.$t('archiv.filter.datum.radio.selecttime')
                      }, null, 8, ["label"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "pt-0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_radio, {
                        value: "allTime",
                        label: _ctx.$t('archiv.filter.datum.radio.alltime')
                      }, null, 8, ["label"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "pt-0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_radio, {
                        value: "specificTime",
                        label: _ctx.$t('archiv.filter.datum.radio.specifictime')
                      }, null, 8, ["label"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "pb-0 pt-0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            class: "pb-0",
                            cols: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_NowhowDatepicker, {
                                modelValue: _ctx.filterData.dateFrom,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filterData.dateFrom) = $event)),
                                disabled: _ctx.radios !== 'specificTime',
                                label: "archiv.filter.datum.von"
                              }, null, 8, ["modelValue", "disabled"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            class: "pb-0",
                            cols: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_NowhowDatepicker, {
                                modelValue: _ctx.filterData.dateTo,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filterData.dateTo) = $event)),
                                disabled: _ctx.radios !== 'specificTime',
                                label: "archiv.filter.datum.bis"
                              }, null, 8, ["modelValue", "disabled"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["visible"])
    ]),
    _: 1
  }))
}